import React from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const ResetPassword = () => {
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const resetPassword = async (data) => {
        const user = {
            phone: data.phoneNumber
        }
        const phoneData = data.phoneNumber;
        console.log(user)

        fetch(`${process.env.REACT_APP_SECRET_API}/reset-password-request`, {
            method: "POST",
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                "content-type": "application/json",
            },
            body: JSON.stringify(user),
        })
            .then((res) => res.json())
            .then((data) => {
                // console.log(data)
                if (data.success === true) {
                    toast.success("Sent otp code");
                    // setToken(data.data.access_token)
                    localStorage.setItem('phone', phoneData)
                    navigate("/resetPassSet")
                } else {
                    toast.error(data.message);
                    console.log(data)
                }
                reset()
            })
    }
    return (
        <div>
            <div className="contain py-16 ">
                <div className="max-w-md bg-white mx-auto shadow px-6 py-7 rounded overflow-hidden">
                    <h2 className="text-2xl uppercase font-medium mb-1 text-center text-black">Reset Password</h2>

                    <div className="divider"></div>
                    <form onClick={handleSubmit(resetPassword)}>
                        <div className="space-y-2">
                            <div>
                                <label htmlFor="otp" className="text-[#0364BE] text-sm lg:text-[16px] mb-2 block">Reset Password</label>
                                <input type="text" name="otp"
                                    className="block bg-white w-full border border-gray-300 px-4 py-2 lg:py-3 text-gray-600 text-sm rounded focus:ring-0 focus:border-primary placeholder-gray-400"
                                    placeholder="012345678901"
                                    {...register("phoneNumber", {
                                        required: {
                                            value: true,
                                            message: "phone number is required"
                                        },
                                        pattern: {
                                            value: /^[0-9]*$/,
                                            message: "Only give number."
                                        },
                                        minLength: {
                                            value: 11,
                                            message: "Must be 11 digits"
                                        },
                                        maxLength: {
                                            value: 11,
                                            message: "No more than 11 digits can be given"
                                        }
                                    })}
                                />
                                <span className='text-xs text-red-500 text-left'>{errors.phoneNumber?.message}</span>
                            </div>
                        </div>

                        <div className="mt-4">
                            <button type="submit"
                                className="block w-full py-2 text-center text-white bg-gradient-to-r from-primary to-[#52a3eb] border border-primary rounded hover:from-[#52a3eb] hover:to-primary transition uppercase font-roboto font-medium">
                                Reset Password
                            </button>
                        </div>
                    </form>
                    {/* <p className="mt-4 text-center text-gray-600">Don't have account? <Link to="/sign-up"
                        className="text-primary">Register
                        now</Link></p> */}
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;